import Info from "./subpages/Info"
import {
  mdiCar,
  mdiEarth,
  mdiFileImage,
  mdiFormatListBulletedSquare,
  mdiInformation,
  mdiOfficeBuilding,
} from "@mdi/js"
import {
  Box,
  CircularProgress,
  Container,
  Typography,
  useTheme,
} from "@mui/material"
import Vehicles from "./subpages/Vehicles"
import Manufacturer from "./subpages/Manufacturer"
import Documents from "./subpages/Documents"
import OE from "./subpages/OE"
import React, { useEffect, useState } from "react"
import ResponsiveBackground from "../../components/ResponsiveBackground"
import { useTecDocStore } from "../../api/services/TecDoc"
import i18next from "i18next"
import tokens from "themes/default/tokens"
import Dialog from "components/Dialog"
import { useHistory } from "react-router"
import { uniq } from "lodash"
import {
  documentImagePath,
  dummyImage,
  iconBookPath,
  isMobile,
} from "utils/Global"
import { scrolltToTop } from "utils/util"
import Tabs from "./components/Tabs"
import CountrySelection from "./components/CountrySelection"
import { useTranslation } from "react-i18next"
import TechnicalInformationconst from "./subpages/TechnicalInformation"
import { observer } from "mobx-react"

export const namespace = __filename

const TecDoc = () => {
  const theme = useTheme()
  const history = useHistory()
  const lang = i18next.language
  const countryCatalogue = localStorage.getItem("countryCatalogueCode") || "de"
  const [isHomeSelected, setIsHomeSelected] = useState(false)
  const { t } = useTranslation()

  const tecDocStore = useTecDocStore()
  const { articleList, articleAttributes, articleDocuments } = tecDocStore

  const [loading, setLoading] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  useEffect(() => {
    scrolltToTop()
  }, [])

  const handleLoading = (value: boolean) => {
    setLoading(value)
  }
  useEffect(() => {
    if (isHomeSelected) setIsHomeSelected(false)
  }, [isHomeSelected])

  function backToHome() {
    setIsHomeSelected(true)
  }

  useEffect(() => {
    if (!articleList) {
      tecDocStore
        .fetchArticle(countryCatalogue, lang, 6, localStorage.getItem("data"))
        .catch((err) => {
          console.error("Error fetching articles", err)
          setIsDialogOpen(true)
        })
    }
    return () => {
      localStorage.removeItem("data")
    }
  }, [tecDocStore, countryCatalogue, lang, articleList])

  useEffect(() => {
    if (articleList && !articleAttributes) {
      tecDocStore
        .fetchArticleDetails(countryCatalogue, lang, articleList?.articleId)
        .catch((err) => {
          console.error("Error fetching articles", err)
          setIsDialogOpen(true)
        })
    }
  }, [tecDocStore, articleList, countryCatalogue, lang, articleAttributes])

  const generalArticleNumber = React.useMemo(() => {
    const requiredKeys = ["articleNo", "articleName", "articleSearchNo"]
    let tempArticleList = []
    let tempDirectArticleList = []

    if (articleList) {
      tempArticleList = Object.entries(articleList).map((item) => {
        return {
          key: item[0],
          subItems: [
            {
              label: requiredKeys.includes(item[0]) ? t(item[0]) : item[0],
              content: String(item[1]),
            },
          ],
        }
      })
    }

    const tempGeneralArticleList = tempArticleList
      .concat(tempDirectArticleList)
      .filter((item) => requiredKeys.includes(item.key))

    return uniq(tempGeneralArticleList)
      .map((item) => item.subItems)
      .map((item) => item[0].content)
  }, [articleList, t])

  const imageProduct = React.useMemo(() => {
    if (articleDocuments && articleDocuments.length > 0) {
      return {
        content: `${documentImagePath}/${articleDocuments[0].docId}/0`,
        docType: articleDocuments[0].docFileTypeName,
        docTypeName: articleDocuments[0].docTypeName,
      }
    }
    return null
  }, [articleDocuments])

  return (
    <ResponsiveBackground theme={theme}>
      <Dialog
        open={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false)
          window.location.href = "/original"
        }}
        confirmStyle={{
          color: tokens.color.primary,
          label: t("confirm"),
        }}
        onAccept={() => {
          setIsDialogOpen(false)
          window.location.href = "/original"
        }}
        title={t("dialogTitle")}
        text={t("dialogText", { ean: localStorage.getItem("data") })}
        hideClose={true}
      />
      <Container sx={{ paddingX: isMobile ? 0 : 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "0px 0px",
            gap: isMobile ? "20px" : "32px",
          }}
        >
          {generalArticleNumber && generalArticleNumber.length > 0 ? (
            <>
              {/* Article Name */}
              <Box sx={{}}>
                <Typography
                  sx={{
                    fontSize: isMobile ? "24px" : "32px",
                    fontWeight: theme.tokens.fonts_Conti.fontWeight_heavy,
                  }}
                >
                  {generalArticleNumber[0]}
                </Typography>
              </Box>
              {/* Article Image & Number */}
              <Box
                sx={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "center",
                }}
              >
                {imageProduct &&
                imageProduct.docType &&
                (imageProduct.docType.startsWith("JPEG") ||
                  imageProduct.docType.startsWith("PNG")) ? (
                  <img
                    src={imageProduct.content}
                    alt=""
                    style={{
                      width: "auto",
                      minWidth: "50px",
                      height: "50px",
                      backgroundColor: "#eee",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <img
                    src={dummyImage}
                    alt=""
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor: "#eee",
                      borderRadius: "8px",
                    }}
                  />
                )}
                <Typography
                  sx={{
                    fontSize: "16px",
                  }}
                >
                  {generalArticleNumber[1]}
                </Typography>
              </Box>
            </>
          ) : (
            // Skeleton
            <>
              <Box
                sx={{
                  backgroundColor: "#eee",
                  height: "48px",
                  width: "400px",
                  maxWidth: "90%",
                  borderRadius: "8px",
                }}
              ></Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#eee",
                    height: "50px",
                    width: "50px",
                    borderRadius: "8px",
                  }}
                ></Box>
                <Box
                  sx={{
                    backgroundColor: "#eee",
                    height: "24px",
                    width: "200px",
                    maxWidth: "70%",
                    borderRadius: "8px",
                  }}
                ></Box>
              </Box>
            </>
          )}

          <Tabs
            isHomeSelected={isHomeSelected}
            type={history?.location?.state?.type}
            icons={[
              { path: mdiCar },
              { path: mdiInformation },
              { path: iconBookPath },
              { path: mdiFileImage },
              { path: mdiFormatListBulletedSquare },
              { path: mdiOfficeBuilding },
              { path: mdiEarth, text: countryCatalogue },
            ]}
            labels={[
              { label: "" },
              { label: "" },
              { label: "" },
              { label: "" },
              { label: "" },
              { label: "" },
              { label: "" },
            ]}
            components={[
              {
                element: <Vehicles handleLoading={handleLoading} />,
                hasPadding: false,
              },
              { element: <Info />, hasPadding: false },
              {
                element: (
                  <TechnicalInformationconst handleLoading={handleLoading} />
                ),
                hasPadding: false,
              },
              { element: <Documents />, hasPadding: false },
              { element: <OE />, hasPadding: false },
              { element: <Manufacturer />, hasPadding: false },
              {
                element: <CountrySelection backToHome={backToHome} />,
                hasPadding: false,
              },
            ]}
            variant={"horizontal"}
            loading={loading}
          />
          {loading && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="10vh"
              sx={{ flexDirection: "column" }}
              marginBottom={theme.spacing(2)}
            >
              <CircularProgress
                style={{ color: tokens.color.primary }}
                size="5vh"
              />
            </Box>
          )}
        </Box>
      </Container>
    </ResponsiveBackground>
  )
}

export default observer(TecDoc)
